import * as React from 'react';

interface ICmdSvigIcon {
  name: string;
  customClassname?: string;
}

export default function CmdSvigIcon(props: ICmdSvigIcon) {
  return (
    <img
      src={`/images/${props.name}.svg`}
      alt={props.name}
      className={`${props.customClassname || ''} cmd-icon`}
    />
  );
}
